export class Result {
    id : number;
    resultCode : string;
    resultName : string;
}